import * as React from 'react'

const Trips = (props: { className: string | null }) => {
  return (
    <svg width='24' height='30' viewBox='0 0 530 704' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M530 324C530 470.355 423.5 548 265 703.5C102 540.5 0 470.355 0 324C0 177.645 118.645 59 265 59C411.355 59 530 177.645 530 324Z'
        fill='#484848'
      />
      <rect x='452.471' y='86.8487' width='70' height='39.5257' transform='rotate(45 452.471 86.8487)' fill='#484848' />
      <rect x='195.988' y='13.0689' width='134' height='35.9401' fill='#484848' />
      <path d='M263.268 113.494L206.032 29.0881L319.479 28.4021L263.268 113.494Z' fill='#484848' />
      <circle cx='268' cy='321' r='200' fill='white' />
      <path d='M288.355 173H234.355V370L288.355 342.5V173Z' fill='#484848' />
      <path d='M288.355 173H234.355V370L288.355 342.5V173Z' fill='#484848' />
      <path d='M288.355 173H234.355V370L288.355 342.5V173Z' fill='#484848' />
      <rect
        x='184.486'
        y='395.178'
        width='50'
        height='83.0467'
        transform='rotate(-116.726 184.486 395.178)'
        fill='#484848'
      />
      <rect
        x='184.486'
        y='395.178'
        width='50'
        height='83.0467'
        transform='rotate(-116.726 184.486 395.178)'
        fill='#484848'
      />
      <rect
        x='184.486'
        y='395.178'
        width='50'
        height='83.0467'
        transform='rotate(-116.726 184.486 395.178)'
        fill='#484848'
      />
    </svg>
  )
}
export default Trips



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Trips.tsx